import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import Collection from "@/pages/Collection";
import Journaling from "@/pages/Journaling";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Bundle from "@/pages/Bundle";
import NotFound from "@/pages/NotFound";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-cream p-8 text-center">
          <div>
            <p className="font-display text-2xl text-ink">Something went sideways.</p>
            <p className="mt-2 text-ink-soft">Take a breath and refresh the page.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  React.useEffect(() => {
    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 0.95 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <SmoothScroll />
        <ScrollManager />
        <div className="min-h-screen bg-cream text-ink antialiased">
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/journaling" element={<Journaling />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/bundle" element={<Bundle />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-center" richColors />
          <div className="grain-overlay" aria-hidden="true" />
        </div>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
